import React from 'react';
import { connect } from 'react-redux';
import {
    FormattedHTMLMessage,
    FormattedMessage,
} from 'react-intl';
import dm from '../translations/en.json';

export const FHTMLMessage = props =>
    <FormattedHTMLMessage
        {...props}
        tagName='span'
        defaultMessage={dm[props.id]}
    />;

export const FMessage = props =>
    <FormattedMessage
        {...props}
        defaultMessage={dm[props.id]}
    />;

const TFMessage = ({ id }) =>
    <FormattedMessage
        id={id}
        defaultMessage={dm[id]}
    />;
const THTMLMessage = ({ id, tagName, defaultMessage }) =>
    <FormattedHTMLMessage
        id={id}
        tagName={tagName}
        defaultMessage={defaultMessage ? defaultMessage : dm[props.id]}
    />;

export const iFMessage = props => {
    if (dm[props.id]) {
        const params = [{
            id: props.id,
            defaultMessage: dm[props.id]
        }];
        if (props.values) {
            params.push(props.values);
        }
        return props.intl.formatMessage(...params);
    } else {
        if (!PRODUCTION) {
            console.warn(`iFMessage => отсутствует перевод для ключа - ${props.id}`);
        }
        return props.defaultText ? props.defaultText : '';
    }
};


const mapStateToProps = state => ({
    theme: state.webmaster.profile.theme
})

export const ThemedFMessage = connect(mapStateToProps)(TFMessage);
export const ThemedHTMLMessage = connect(mapStateToProps)(THTMLMessage);